<!-- ScheduleMessage.vue -->
<script lang="ts" setup>
    //import * as MessageLib from "messagelib"
    import { onMounted } from 'vue';

    // Outgoing message methods
    defineExpose({openPatient, loadReminderSchedule, openPatientSetup, printLetter, performAction});

    // EVents from incoming messages
	const emit = defineEmits<{
		(e: "openPatient", payload: MessageLib.Scheduler.OpenPatientPayload):void,
		(e: "loadReminderSchedule", payload: MessageLib.Scheduler.LoadReminderSchedulePayload):void,
		(e: "openPatientSetup", payload: MessageLib.Scheduler.OpenPatientSetupPayload):void,
		(e: "printLetter", payload: MessageLib.Scheduler.PrintLetterPayload):void,
		(e: "performAction", payload: MessageLib.Scheduler.PerformActionPayload):void,
	}>();
    

    onMounted(()=>{
        MessageLib.Scheduler.sink.openPatient(openPatientSink);
        MessageLib.Scheduler.sink.loadReminderSchedule(loadReminderScheduleSink);
        MessageLib.Scheduler.sink.openPatientSetup(openPatientSetupSink);
        MessageLib.Scheduler.sink.printLetter(printLetterSink);
        MessageLib.Scheduler.sink.performAction(performActionSink);
    });

    // Raise message events
	function openPatientSink(payload: unknown)
	{
        emit("openPatient", <MessageLib.Scheduler.OpenPatientPayload>payload);
	}
	function loadReminderScheduleSink(payload: unknown)
	{
        emit("loadReminderSchedule", <MessageLib.Scheduler.LoadReminderSchedulePayload>payload);
	}
	function openPatientSetupSink(payload: unknown)
	{
        emit("openPatientSetup", <MessageLib.Scheduler.OpenPatientSetupPayload>payload);
	}
	function printLetterSink(payload: unknown)
	{
        emit("printLetter", <MessageLib.Scheduler.PrintLetterPayload>payload);
	}
	function performActionSink(payload: unknown)
	{
        emit("performAction", <MessageLib.Scheduler.PerformActionPayload>payload);
	}

    // Send Messages
    function openPatient(payload: MessageLib.Scheduler.OpenPatientPayload)
    {
        MessageLib.Scheduler.openPatient(payload);
    }
    function loadReminderSchedule(payload: MessageLib.Scheduler.LoadReminderSchedulePayload)
    {
        MessageLib.Scheduler.loadReminderSchedule(payload);
    }
    function openPatientSetup(payload: MessageLib.Scheduler.OpenPatientSetupPayload)
    {
        MessageLib.Scheduler.openPatientSetup(payload);
    }
    function printLetter(payload: MessageLib.Scheduler.PrintLetterPayload)
    {
        MessageLib.Scheduler.printLetter(payload);
    }
    function performAction(payload: MessageLib.Scheduler.PerformActionPayload)
    {
        MessageLib.Scheduler.performAction(payload);
    }


</script>